import React from 'react';
import { motion } from 'framer-motion'; // Import motion
import Icon from '../../../components/AppIcon';

const ProjectStats = ({ stats }) => {
  const statItems = [
    {
      icon: 'Briefcase',
      value: stats.totalProjects,
      label: 'Projects Completed',
      color: 'text-gray-900' // Dark grey for icon
    },
    {
      icon: 'Users',
      value: stats.clientsSatisfied,
      label: 'Clients Satisfied',
      color: 'text-gray-700' // Medium-dark grey for icon
    },
    {
      icon: 'Globe',
      value: stats.industriesServed,
      label: 'Industries Served',
      color: 'text-gray-500' // Medium grey for icon
    },
    {
      icon: 'Award',
      value: stats.averageROI,
      label: 'Average ROI',
      color: 'text-gray-400' // Lighter grey for icon
    }
  ];

  // Define variants for the container animation
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
        staggerChildren: 0.1 // Stagger the animation of child items
      }
    }
  };

  // Define variants for the individual stat item animation
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    // Wrap the main div with motion.div and apply variants
    <motion.div
      className="glass-morph bg-gradient-to-r from-gray-100/20 via-gray-200/20 to-gray-300/20 backdrop-blur-md border border-gray-100/10 rounded-xl p-6"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible" // Animation triggers when component enters viewport
      viewport={{ once: true, amount: 0.3 }} // Play animation only once, when 30% of component is in view
    >
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-gray-900 font-heading mb-2">
          Our Project Impact
        </h3>
        <p className="text-gray-700">
          Transforming businesses across industries with measurable results
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {statItems.map((item, index) => (
          // Wrap each stat item with motion.div and apply item variants
          <motion.div key={index} className="text-center space-y-3" variants={itemVariants}>
            <div className="w-16 h-16 mx-auto bg-white/50 backdrop-blur-sm border border-gray-200 rounded-full shadow-md flex items-center justify-center">
              <Icon
                name={item.icon}
                size={24}
                className={item.color}
              />
            </div>

            <div className="space-y-1">
              <div className="text-2xl font-bold text-gray-800">
                {item.value}
              </div>
              <div className="text-sm text-gray-600">
                {item.label}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ProjectStats;